import { render } from "./BuildType.vue?vue&type=template&id=cb89bcf0&scoped=true"
import script from "./BuildType.vue?vue&type=script&lang=ts"
export * from "./BuildType.vue?vue&type=script&lang=ts"

import "./BuildType.vue?vue&type=style&index=0&id=cb89bcf0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cb89bcf0"

export default script